import classNames from 'classnames';
import { CurrencySymbol } from 'components/shared/NewAmountInput/CurrencySymbol';
import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import { HighlightColor } from 'components/shared/NumberFormatter/NumberFormatter.model';
import { IntlKey } from 'locales';
import { useState } from 'react';

import './style.scss';
import { FormattedMessage } from 'react-intl';
import { amountDefaultAccelerators } from 'utils/amount';

type Props = {
  id: string;
  value: Nullable<number>;
  setValue: (value: Nullable<number>) => void;
  currency: string;
  isReadOnly: boolean | undefined;
  nbDecimals?: number;
  hasError: boolean;
  highlightColor?: HighlightColor;
};
export function Amount({ currency, hasError, id, isReadOnly, nbDecimals, setValue, value, highlightColor }: Props) {
  const [focused, setFocused] = useState(false);

  return (
    <div
      className={classNames('bg-lvl1 px-0 card card-bordering', {
        active: focused && !isReadOnly,
        'border-bottom border-warning': hasError,
      })}
      role="label"
    >
      <div className="w-auto px-12px flex-x align-items-center input-icon-start" style={{ height: '40px' }}>
        <label htmlFor={id} className="text-secondary">
          <FormattedMessage id={`essential.form.${id}` as IntlKey} defaultMessage="Notion" />
        </label>
      </div>

      <div className="flex-x align-items-baseline">
        <span className="text-secondary fs-1 ps-12px">
          <CurrencySymbol code={currency} />
        </span>

        <NumberFormatter
          value={value}
          onFocus={() => setFocused(true)}
          onBlur={v => {
            setValue(v ?? null);
            setFocused(false);
          }}
          className="fs-1 fw-medium border-0 amount-field"
          precision={nbDecimals}
          incrementStep={1_000_000}
          isDisabled={isReadOnly}
          id={id}
          accelerators={amountDefaultAccelerators}
          highlightColor={highlightColor}
        />
      </div>
    </div>
  );
}
